import { IUser } from '../modules/Login/Access/Interfaces';

//Start Common
export const STATIC_ROOT_PATH = window.location.origin;
//End Common

const {
  REACT_APP_BACKEND_SERVICE_URL,
  REACT_APP_IMAGE_SERVICE_URL,
  REACT_APP_API_BASE_CONTENT,
  REACT_APP_API_BASE_PUBLISH,
  REACT_APP_XIQ_ONLINE_URL,
  REACT_APP_STAGING_BACKEND_URL,
  REACT_APP_API_BASE_CAMPAIGN,
  REACT_APP_API_BASE_ASSET,
  REACT_APP_API_BASE_AUDIENCE,
  REACT_APP_API_BASE_ANALYTICS,
  REACT_APP_STATIC_TEMPLATES_IMAGE_URL,
  REACT_APP_WORKBENCH_DASHBOARD_URL,
  REACT_APP_SERVERLESS,
  REACT_APP_SALES_XELERATOR_URL,
  REACT_APP_API_BASE_WORKFLOW,
  REACT_APP_API_BASE_PREFERENCE_MANAGEMENT,
  REACT_APP_LINK,
  REACT_APP_AUTH_BACKEND_URL,
  REACT_APP_API_BUYER_JOURNEY,
} = process.env;

// Start Login
export const WELCOME_TRANSITION_DURATION = 1000;
export const WELCOME_DELAY = 0;
// End Login

// User Cookies
export let ACCESS_ID = '';
export let USER_FIRSTNAME = '';
export let USER_LASTNAME = '';
export let USER_APPNAME = '';
export let USER_EMAIL = '';

export const setCookies = (value: IUser) => {
  ACCESS_ID = value.token;
  USER_FIRSTNAME = value.firstname;
  USER_LASTNAME = value.lastname;
  USER_EMAIL = value.email;
  USER_APPNAME = value.signup_appname;
};
// End User Cookies

// export const BACKEND_SERVICE_URL = "https://staging-backend.xiqonline.com";
export const BACKEND_SERVICE_URL = REACT_APP_BACKEND_SERVICE_URL;
// export const IMAGE_SERVICE_URL = "https://images.xiq.io"; Prod
export const IMAGE_SERVICE_URL = REACT_APP_IMAGE_SERVICE_URL;
export const IMAGE_SERVICE_URL_STAGING = 'https://stageimg.xiq.io';
export const STATIC_TEMPLATES_IMAGE_URL = REACT_APP_STATIC_TEMPLATES_IMAGE_URL;

// export const API_BASE_CONTENT = "http://127.0.0.1:8000/content/";
export const API_BASE_CONTENT = REACT_APP_API_BASE_CONTENT;
export const API_BASE_PUBLISH = REACT_APP_API_BASE_PUBLISH;
// export const API_BASE_PUBLISH = "http://127.0.0.1:8001/publish/";
// export const API_BASE_CAMPAIGN = "http://127.0.0.1:8001/campaigns/";
export const API_BASE_CAMPAIGN = REACT_APP_API_BASE_CAMPAIGN;
export const API_BASE_ASSET = REACT_APP_API_BASE_ASSET;
// export const API_BASE_ASSET = "http://127.0.0.1:8001/assets/";
export const API_BASE_AUDIENCE = REACT_APP_API_BASE_AUDIENCE;
export const API_BASE_ANALYTICS = REACT_APP_API_BASE_ANALYTICS;
export const API_BASE_PREFERENCE_MANAGEMENT = REACT_APP_API_BASE_PREFERENCE_MANAGEMENT;
export const API_BASE_WORKFLOW = REACT_APP_API_BASE_WORKFLOW;
export const WORKBENCH_DASHBOARD_URL = REACT_APP_WORKBENCH_DASHBOARD_URL;
export const APP_SERVERLESS = REACT_APP_SERVERLESS;
export const BASE_PATH_UNSUB = REACT_APP_LINK;
export const API_BASE_AUTH = REACT_APP_AUTH_BACKEND_URL + 'auth/v1/';
export const API_BASE_BUYER_JOURNEY = REACT_APP_API_BUYER_JOURNEY;

export const PATH_HAPPENING_NOW = 'explorer';
export const PATH_MY_ACCOUNTS = 'myaccounts';
export const PATH_FAVOURITES = 'favorites';
export const PATH_SEARCH = 'search';
export const PATH_MOST_ENGAGED = 'most-engaged';
export const PATH_PREFERENCE_MANAGEMENT = 'unsub';
export const PATH_PREFERENCE_MANAGEMENT_SUCCESS = 'unsub-success';

//Login
export const CAPTCHA_SITE_KEY = '6Le6Xa0UAAAAAPwQh05zVZ1eAwzXOxMWzPcZtLxg';
export const LOGIN = BACKEND_SERVICE_URL + '/v2/v3.0/login/';
export const SIGNUP = BACKEND_SERVICE_URL + '/v2/v4.0/signup/';
export const LOGOUT = BACKEND_SERVICE_URL + '/logoutservice/';
export const RESET_PASSWORD = BACKEND_SERVICE_URL + '/forgotpassword/';
export const SUPPORT_EMAIL = 'mailto:support@xiqinc.com?subject=Retrieve My Username/Email Address';
export const SET_NEW_PASSWORD = BACKEND_SERVICE_URL + '/v2/resetpassword/';

// Share Article to Social Networks
export const GOOGLE_PLUS_SHARE_PREFIX = 'https://plus.google.com/share?url=';
export const FACEBOOK_SHARE_PREFIX = 'https://www.facebook.com/sharer/sharer.php?u=';
export const LINKEDIN_URL_PREFIX = 'https://www.linkedin.com/sharing/share-offsite/?url=';
export const TWITTER_SHARE_URL_PREFIX = 'https://twitter.com/intent/tweet?text=';
export const HOOTSUITE_URL_PREFIX = 'https://hootsuite.com/hootlet/social-share?url=';
// End Share Article to Social Networks

// get csrf token from OTP
export const GET_CSRF_FROM_OTP = REACT_APP_STAGING_BACKEND_URL + 'v2/getcsrf/';
export const XIQ_ONLINE_URL = REACT_APP_XIQ_ONLINE_URL;
export const XIQ_SALES_XELERATOR_URL = REACT_APP_SALES_XELERATOR_URL;
export const TIMEOUT_LIMIT = 60 * 1000 * 5; //2 minutes
export const SECTION_ID = '001122';

export const TEMP_ASSET_NAME = 'Draft Asset';
export const TEMP_VERSION_NAME = 'Draft Edition';
export const ASSET_TYPE = {
  HYBRID: 'hybrid',
  CUSTOM: 'custom',
};

// default image placeholder
export const DEFAULT_IMAGE_PLACEHOLDER =
  IMAGE_SERVICE_URL + '/returnimage/?url=&width=95&height=95&articleid=357964118&detectface=true&app_name=wb';
export const GILL_ROY_DESK_ICON = `https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/assets/G1.svg`;

export const ANALYTICS_CAMPAIGNS_ID = {
  SHARED_PROFILE: 1,
  DAILY_IQ: 2,
  WEEKLY_ACCOUNTS_INSIGHTS: 3,
};

export const EMAIL_TYPE_MAP: any = {
  all: '',
  adhoc: '1',
  digest: '0',
  aiEmail: '2',
};

export const getScreenResolution: any = {
  xs: {
    maxWidth: 0.75,
    padding: 20,
  },
  sm: {
    maxWidth: 0.3333,
    padding: 30,
  },
  md: {
    maxWidth: 0.25,
    padding: 40,
  },
  lg: { maxWidth: 0.25, padding: 40 },
  xxl: {
    maxWidth: 0.1666666667,
    padding: 56,
  },
};

export const getScreenResolutionName = (num: number) => {
  switch (true) {
    case num > 1600:
      return 'xxl';
    case num > 1200:
      return 'lg';
    case num > 992:
      return 'md';
    case num > 768:
      return 'sm';
    case num > 578:
      return 'xs';
    default:
      return 'xs';
  }
};

export const hideFreshDeskUrl = [
  '/campaigns/editionedit/',
  '/campaigns/editionedit',
  '/campaigns/editionedit/design/',
  '/campaigns/editionedit/publish/',
];

export const I2C_ADMIN_ID = 4708; // I2C's user admin id
export const AZIL_ADMIN_ID = 14764; // Azil's user admin id
export const ALLOWED_ADMIN_IDS_FOR_I2C = [I2C_ADMIN_ID, AZIL_ADMIN_ID];

// Colors
export const primaryBgColor = 'rgb(249,248,246)';
export const SecondaryBgColor = 'rgb(255,255,255)';
export const primaryColor = '#1EC252';
export const SecondaryColor = '#001760';
export const boxShadow = '0px 0px 24px rgba(0, 0, 0, 0.102473)';
export const primaryHeadingColor = '#424B50';
export const appBgColor = '#f9f8f6';
export const SecondaryColorTwo = '#5E7079';
export const favouriteArticleColor = '#1EC252';
export const whiteColor = '#B4B4B4';
export const greyColor = '#7E7E7E';

// Regulations
export const max = '1921px';
export const med = '1441px';
export const min = '1025px';

// Media
export const maxWidth = '1500px';
export const maxHeight = '1080px';
export const maxWidth1300 = '1300px';
export const maxWidth1170 = '1170px';
export const minWidthApp = '1100px';
export const maxTablet = '1023px';
export const midTablet = '993px';
export const maxMobile = '767px';
export const midMobile = '575px';
export const smMobile = '480px';
export const xmMobile = '380px';

// export const retina = '(000)';
export const retina = '(-webkit-device-pixel-ratio: 1.25)';
export const retinaOne = '(-webkit-device-pixel-ratio: 1)';
// Fonts
export const primaryFont = 'Roboto';
export const secondaryFont = 'Roboto Slab';

export const wELight = '300';
export const wLight = '400';
export const wMedium = '500';
export const wMBold = '700';
export const wBold = '900';

export const GILL_LOADING =
  'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/assets/Gilroy_AnimationsGilroy_Loading.gif';
export const GILL_HAPPY_FACE = 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/assets/G2.svg';
export const GILL_SAD_FACE = 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/assets/G3.svg';
export const GILL_REGENERATE_FACE = 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/assets/G9.svg';
export const GILL_REGENERATE_GIF =
  'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/assets/Gilroy_Animations_1.gif';
export const GILL_DELETE_LOADING =
  'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/workBench/assets/gilroy-delete-icon.gif';
